<template>
  <BaseBoxColor variant="gray" class="w-full p-4">
    <GridRow>
      <GridCol :span-md="7" class="space-y-4">
        <div class="flex items-center gap-x-4">
          <h3>{{ name }}</h3>
          <BaseBadge
            :variant="enabled ? 'success' : 'danger'"
            class="bg-opacity-70"
            >{{ enabled ? $t("online") : $t("offline") }}</BaseBadge
          >
        </div>
        <div class="flex gap-4 items-center">
          <div>
            <h4 class="text-sm uppercase text-white/75">{{ $t("token") }}</h4>
            <BaseToken :token="token" />
          </div>
          <div>
            <h4 class="text-sm uppercase text-white/75">{{ $t("type") }}</h4>
            <strong> {{ type }}</strong>
          </div>
          <div v-if="cidr">
            <h4 class="text-sm uppercase text-white/75">{{ $t("cidr") }}</h4>
            <strong> {{ cidr }}</strong>
          </div>
        </div>
        <div>
          <h4 class="text-sm uppercase text-white/75">{{ $t("usage") }}</h4>
          <div>
            <StandardChart v-if="props.chartOptions" class="h-[12.5rem] w-full" :options="props.chartOptions" />
          </div>
        </div>
          
      </GridCol>
      <GridCol class="flex flex-col gap-2" :span-md="5">
        <div class="mb-2">
          <h6 class="text-end text-white/75">#{{ code }}</h6>
        </div>
        <div class="flex flex-col border border-white/10 p-2 rounded-lg h-full">
          <div class="mb-2 flex items-center">
            <h4 class="text-sm uppercase text-white/75">{{ $t("scopeList") }}</h4>
            <BaseButton
              variant="primary"
              :outline="true"
              size="xs"
              class="ml-auto"
              @click="isScopeListEditing = !isScopeListEditing"
            >
              {{ !isScopeListEditing ? $t("manage") : $t("close") }}
            </BaseButton>
          </div>
          <BaseBoxColor variant="darkGray" class="w-full flex flex-grow border border-white/10">
            <div class="w-full">
              <div v-if="Scopes.length === 0 && !isScopeListEditing">
                {{ $t("noScopes") }}
              </div>
              <div v-if="!isScopeListEditing" class="flex flex-col gap-2">
                <BaseBadge  class="space-y-1 bg-opacity-70 w-fit" v-for="scope in Scopes">
                  {{ scope.prefix }}/{{ scope.slug }}
                </BaseBadge>
              </div>
              <ScopeListForm
                v-else
                :current-scopes="Scopes"
                :id="id"
                :name="name"
                :type_id="type_id"
              />
            </div>
          </BaseBoxColor>
        </div>
        <div class="flex justify-end items-end flex-grow">
          <InputSwitch
            class="self-end h-fit"
            :label="$t('enabled')"
            :initial-value="props.enabled"
            name="enabled"
            @change="toggleEnabled(id)"
          />
        </div>
      </GridCol>
    </GridRow>
  </BaseBoxColor>
</template>

<script setup>
import { ref } from "vue";
import ScopeListForm from "./ScopeListForm.vue";
import useChannelStore from "@/stores/channel";

const { toggleEnabled } = useChannelStore();

const props = defineProps({
  id: {
    type: [String, Number],
    required: true,
  },
  code: {
    type: String,
    default: "code",
  },
  name: {
    type: String,
    required: true,
  },
  type_id: {
    type: [String, Number],
  },
  type: {
    type: String,
    required: true,
  },
  token: {
    type: String,
    required: true,
  },
  enabled: {
    type: Boolean,
    default: false,
  },
  Scopes: {
    type: Array,
    default: () => [],
  },
  cidr: {
    type: [String, null],
    required: true,
  },
  chartOptions: {
    type: Object,
  },
});

const isScopeListEditing = ref(false);
</script>
